/**
 * Implements a component
 */

import Image from '../../../../atoms/Image';
import { ColumnNames, ColumnTitles } from '../columns';
import shevronDown from '../../../../assets/images/shevron_down.svg';
import shevronUp from '../../../../assets/images/shevron_up.svg';
import Text from '../../../../atoms/Text';

const CEX_columns = [
  {
    name: ColumnNames.pair,
    title: ColumnTitles.pair,
    filterable: false,
  },
  {
    name: ColumnNames.price,
    title: ColumnTitles.price,
    filterable: true,
  },
  {
    name: ColumnNames.liquidity,
    filterable: false,
  },
  {
    name: ColumnNames.volume,
    title: ColumnTitles.volume,
    filterable: true,
  },
  {
    name: ColumnNames.exchange,
    filterable: false,
  },
  {
    name: ColumnNames.star,
    filterable: false,
  },
];
const DEX_columns = [
  {
    name: ColumnNames.pair,
    title: ColumnTitles.pair,
    filterable: false,
  },
  {
    name: ColumnNames.price,
    title: ColumnTitles.price,
    filterable: true,
  },
  {
    name: ColumnNames.liquidity,
    title: ColumnTitles.liquidity,
    filterable: true,
  },
  {
    name: ColumnNames.volume,
    title: ColumnTitles.volume,
    filterable: true,
  },
  {
    name: ColumnNames.contract,
    title: ColumnTitles.contract,
    filterable: false
  },
  {
    name: ColumnNames.apy,
    title: ColumnTitles.apy,
    filterable: true,
  },
  {
    name: ColumnNames.star,
    filterable: false,
  },
];

const getSymbol = (selected: any, name: string) =>
  selected
    ? selected.name === name
      ? selected.order === 'DESC'
        ? <Image src={shevronDown} size='s' />
        : <Image src={shevronUp} size='s' />
      : ''
    : '';

const Column = ({ column, selected, onSelect }: any) => {
  const { name, title, filterable } = column;

  const onClick = () => {
    if (selected) {
      if (selected.name === name) {
        if (selected.order === 'ASC') {
          onSelect({ ...selected, order: 'DESC' });
        } else {
          onSelect({ ...selected, order: 'ASC' });
        }
      } else {
        onSelect({ name, order: 'DESC' });
      }
    } else {
      onSelect({ name, order: 'DESC' });
    }
  };

  if (filterable) {
    return (
      <div className={`tickers__panel__table__row__${name} tickers__panel__table__row__${name}--head`} onClick={onClick}>
        <Text size={12}>{title ? title : ' '}</Text>
        {getSymbol(selected, name)}
      </div>
    );
  }

  return <div className={`tickers__panel__table__row__${name} tickers__panel__table__row__${name}--head`}><Text size={12}>{title}</Text></div>;
};

export { Column, CEX_columns, DEX_columns };
